import("@/webComponents/defineWebComponents").then((defineWebComponents) =>
  defineWebComponents.default()
)

export {}
